/* eslint-disable max-len */
export const osnPlayIndicatorIcon = {
  data: `<svg width="144" height="144" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M38.0923 30.189L107.295 70.7543C107.966 71.1474 108.199 72.0237 107.816 72.7116C107.692 72.934 107.512 73.1184 107.295 73.2454L38.0923 113.811C37.4217 114.204 36.5675 113.965 36.1843 113.277C36.0635 113.06 36 112.815 36 112.565V31.4346C36 30.6423 36.6261 30 37.3985 30C37.6418 30 37.881 30.0652 38.0923 30.189Z" fill="currentColor"/>
  </svg>
  `,
  name: 'play-indicator',
};
